import { useQuery } from "@tanstack/react-query";
import {
  getCustomerDetails,
  getCustomerMetadata,
  getCustomerRemoveReasons,
  getSignUpPrefillData,
} from "./services";
import { type IGetSignUpPrefillDataRequest } from "./types";

export const useCustomerDetailsQuery = () => {
  return useQuery({
    queryKey: ["customer", "details"],
    queryFn: getCustomerDetails,
    staleTime: Infinity,
  });
};

export const useCustomerMetadataQuery = (enabled?: boolean) =>
  useQuery({
    queryKey: ["customer", "metadata"],
    queryFn: getCustomerMetadata,
    staleTime: Infinity,
    enabled,
  });

export const useCustomerRemoveReasonsQuery = () =>
  useQuery({
    queryKey: ["customerRemoveReasons"],
    queryFn: getCustomerRemoveReasons,
    staleTime: Infinity,
  });

export const useSignUpPrefillDataQuery = (
  data: IGetSignUpPrefillDataRequest,
  enabled: boolean,
) =>
  useQuery({
    queryKey: ["signUpPrefillData", data.e],
    queryFn: () => getSignUpPrefillData(data),
    staleTime: Infinity,
    enabled,
  });
